import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';

import { GridItem } from 'common/components/Grid';
import { BodyRegularBR1, HeadlineH5 } from 'common/components/Typography';

interface UspHeaderProps {
  title: Nullable<string>;
  subtitleHtml?: string;
  id?: string;
}

const uspHeaderGridItemStyles = {
  mt: 'sp_32',
  mb: 'sp_24',
};

const titleStyles: ComponentProps<typeof HeadlineH5> = {
  color: 'inherit',
  m: 'sp_0',
  as: 'h2',
};

const Subtitle = styled(BodyRegularBR1)`
  & > * {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const UspHeader = ({ title, subtitleHtml, id }: UspHeaderProps) => (
  <GridItem {...uspHeaderGridItemStyles}>
    <HeadlineH5 {...(id ? { id } : {})} {...titleStyles}>
      {title}
    </HeadlineH5>
    {!!subtitleHtml && (
      <Subtitle
        mt={['sp_16', 'sp_20']}
        color="inherit"
        dangerouslySetInnerHTML={{ __html: subtitleHtml }}
      />
    )}
  </GridItem>
);
